import React, { useEffect, useState } from "react";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import connector from "../../resources/connector.svg";
import stepperCheckMark from "../../resources/stepper-checkmark.svg";
import stepper2 from "../../resources/stepper-2.svg";
import stepper3 from "../../resources/stepper-3-disabled.svg";
import { logFunctions as log } from "../../util/Logging";
import DropDownSelect from "../utilities/DropDownSelect";

function SelectSiteAndWallIDScreen(props) {
  log.debug("+SelectSiteAndWallIDScreen(TRACE)");

  const { t } = useTranslation("translation");
  const [siteListInd, setSiteListInd] = useState("");
  const [scannerWallListInd, setScannerWallListInd] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);

  var sitesList = props.sitesList;

  let scannerWallsList = [
    {
      scannerWallId: "1",
      name: "Scannerwall 1",
    },
    {
      scannerWallId: "2",
      name: "Scannerwall 2",
    },
    {
      scannerWallId: "3",
      name: "Scannerwall 3",
    },
    {
      scannerWallId: "4",
      name: "Scannerwall 4",
    },
  ];

  useEffect(() => {
    if (siteListInd !== "" && scannerWallListInd !== "") {
      setContinueBtn(true);
    }
  }, [siteListInd, scannerWallListInd]);

  const handleSiteChange = (site) => {
    setSiteListInd(site);
  };

  const handleWallChange = (wall) => {
    setScannerWallListInd(wall);
  };

  const handleSubmitSiteAndWall = () => {
    log.debug("+SelectSiteAndWallIDScreen_handleSubmitSiteAndWall(TRACE)");
    if (siteListInd === -1 || scannerWallListInd === "") {
      log.error(
        "SelectSiteAndWallIDScreen_handleSubmitSiteAndWall() => Invalid siteID or wallID"
      );
      log.debug("-SelectSiteAndWallIDScreen_handleSubmitSiteAndWall(TRACE)");
      return;
    }
    localStorage.setItem("siteID", sitesList[siteListInd].id);
    localStorage.setItem(
      "wallID",
      scannerWallsList[scannerWallListInd].scannerWallId
    );
    log.info(
      "SelectSiteAndWallIDScreen_handleSubmitSiteAndWall() => siteID: %s, wallID: %s",
      localStorage.getItem("siteID"),
      localStorage.getItem("wallID")
    );
    log.debug("-SelectSiteAndWallIDScreen_handleSubmitSiteAndWall(TRACE)");
    props.transitionToConfiguringScreen();
  };

  log.debug("-SelectSiteAndWallIDScreen(TRACE)");
  return (
    <div className="Screen">
      <div className="contentContainer">
        <div className="stepperContainer">
          <img
            id="stepper1"
            src={stepperCheckMark}
            alt="stepper1"
            className="stepperNumber"
          />
          <p id="step1TextLabel">{t("Scan QR Code")}</p>
          <img id="connector1" src={connector} alt="connector1" />
          <img
            id="stepper2"
            src={stepper2}
            alt="stepper2"
            className="stepperNumber"
          />
          <p id="step2TextLabel">{t("Set location and ID")}</p>
          <img id="connector2" src={connector} alt="connector2" />
          <img
            id="stepper3"
            src={stepper3}
            alt="stepper3"
            className="stepperNumber"
          />
          <p id="step3TextLabel">{t("Finish configuration")}</p>
        </div>
        <div className="selectIDTextBox" id="selectIDLabel">
          <p>
            {t("Please select location and ID settings for this Scannerwall")}
          </p>
        </div>
        <div className="selectContainer">
          <div className="dropDownSelectBox">
            <label id="storeLocationDropDownLabel">{t("Store location")}</label>
            <DropDownSelect
              dropDownOptions={sitesList}
              handleSite={handleSiteChange}
            />
          </div>
          <div className="dropDownSelectBox">
            <label id="scannerIdDropDownLabel">{t("Scannerwall ID")}</label>
            <DropDownSelect
              dropDownOptions={scannerWallsList}
              handleWall={handleWallChange}
            />
          </div>
        </div>
        <img
          src={require("../../resources/selectidbottom.png")}
          alt=""
          width={870}
          height={218}
          className="selectScreenBottom"
          id="selectScreenBottomImg"
        ></img>
      </div>
      <div className="footerContainer" id="footer">
        <Footer
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          transitionToStagingScreen={props.transitionToStagingScreen}
          transitionToLoadingScreen={handleSubmitSiteAndWall}
          state={AppState.SELECT_SITE_AND_WALL_ID_SCREEN}
          selectIdScreenContinueBtn={continueBtn}
        />
      </div>
    </div>
  );
}

export default SelectSiteAndWallIDScreen;
